import {
  select_styles_default
} from "./chunk.ZUM2U5L3.js";
import {
  FormElementRenderer
} from "./chunk.WYCOG7TZ.js";
import {
  credit_card_icons_exports,
  csc
} from "./chunk.4LHSXYZ4.js";
import {
  credit_card_styles_default
} from "./chunk.VZY5MI7F.js";
import {
  form_control_standard_styles_default
} from "./chunk.3IKJ6Y74.js";
import {
  form_control_styles_default
} from "./chunk.EK4QQDDG.js";
import {
  form_control_floating_styles_default
} from "./chunk.AHN6JZAS.js";
import {
  form_control_monochrome_styles_default
} from "./chunk.JUOLR3MG.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/credit-card/credit-card.ts
import { t as t2 } from "i18next";
var id = 0;
var secureChar = "\u2022";
function checkLuhn(cardNo) {
  const nDigits = cardNo.length;
  let nSum = 0;
  let isSecond = false;
  for (let i2 = nDigits - 1; i2 >= 0; i2--) {
    let d = cardNo[i2].charCodeAt(0) - "0".charCodeAt(0);
    if (isSecond === true)
      d *= 2;
    nSum += parseInt(`${d / 10}`, 10);
    nSum += d % 10;
    isSecond = !isSecond;
  }
  return nSum % 10 === 0;
}
var FadvCreditCard = class extends s {
  constructor() {
    super(...arguments);
    this.ccFormId = `credit-card-${id++}`;
    this.floating = true;
    this.variant = "primary";
    this.pill = true;
    this.disabled = false;
    this.readonly = false;
    this.validateLuhn = true;
  }
  connectedCallback() {
    super.connectedCallback();
    this.firstNameRenderer = new FormElementRenderer(this, "input", () => this.firstNameInput);
    this.lastNameRenderer = new FormElementRenderer(this, "input", () => this.lastNameInput);
    this.cardNumberRenderer = new FormElementRenderer(this, "input", () => this.cardNumberInput);
    this.monthRenderer = new FormElementRenderer(this, "select", () => this.monthSelect);
    this.yearRenderer = new FormElementRenderer(this, "select", () => this.yearSelect);
    this.cscRenderer = new FormElementRenderer(this, "input", () => this.cscInput);
  }
  firstUpdated() {
    this.firstNameRenderer.connect();
    this.lastNameRenderer.connect();
    this.cardNumberRenderer.connect();
    this.monthRenderer.connect();
    this.yearRenderer.connect();
    this.cscRenderer.connect();
    this.firstNameRenderer.addValidator(() => !this.firstNameInput.value);
    this.lastNameRenderer.addValidator(() => !this.lastNameInput.value);
    this.cardNumberRenderer.addValidator(() => !this.cardNumberInput.value);
    this.cardNumberRenderer.addValidator(() => this.validateLuhn && !checkLuhn(this.cardNumber));
    this.monthRenderer.addValidator(() => !this.monthSelect.value);
    this.monthRenderer.addValidator(() => {
      const isInvalid = !this.isExpiryValid();
      this.yearRenderer.invalid = isInvalid;
      return isInvalid;
    });
    this.yearRenderer.addValidator(() => !this.yearSelect.value);
    this.yearRenderer.addValidator(() => {
      const isInvalid = !this.isExpiryValid();
      this.monthRenderer.invalid = isInvalid;
      return isInvalid;
    });
    this.cscRenderer.addValidator(() => !this.cscInput.value);
    if (this.cardNumber) {
      this.handleCardNumberInput();
      this.handleCardNumberBlur();
    }
    if (this.csc) {
      this.handleCscNumberBlur();
    }
  }
  disconnectedCallback() {
    this.firstNameRenderer.disconnect();
    this.lastNameRenderer.disconnect();
    this.cardNumberRenderer.disconnect();
    this.monthRenderer.disconnect();
    this.yearRenderer.disconnect();
    this.cscRenderer.disconnect();
    super.disconnectedCallback();
  }
  isExpiryValid() {
    const month = parseInt(this.monthSelect.value, 10);
    const year = parseInt(this.yearSelect.value, 10);
    if (!month || isNaN(month)) {
      return false;
    }
    if (!year || isNaN(year)) {
      return false;
    }
    const currentDate = new Date(Date.now());
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    return year > currentYear || currentYear === year && month > currentMonth;
  }
  handleRestrictedKeydown(event) {
    const allowedKeys = ["Delete", "Home", "End", "Backspace", "Tab", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];
    if (!allowedKeys.includes(event.key) && !event.ctrlKey) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
  handleInputChange(event) {
    var _a, _b;
    this.firstName = this.firstNameInput.value.trim();
    this.lastName = this.lastNameInput.value.trim();
    this.month = this.monthSelect.value.trim();
    this.year = this.yearSelect.value.trim();
    if (event.target === this.cardNumberInput && !((_a = this.cardNumberInput.value) == null ? void 0 : _a.includes(secureChar))) {
      this.cardNumber = this.cardNumberInput.value.trim();
    }
    if (event.target === this.cscInput && !((_b = this.cscInput.value) == null ? void 0 : _b.includes(secureChar))) {
      this.csc = this.cscInput.value.trim();
    }
    emit(this, "credit-card-changed", {
      detail: {
        firstName: this.firstName,
        lastName: this.lastName,
        cardNumber: this.cardNumber,
        month: this.month,
        year: this.year,
        csc: this.csc
      }
    });
  }
  handleInputBlur() {
    emit(this, "credit-card-validation-results", {
      detail: {
        firstName: this.firstNameRenderer.invalid,
        lastName: this.lastNameRenderer.invalid,
        cardNumber: this.cardNumberRenderer.invalid,
        month: this.monthRenderer.invalid,
        year: this.yearRenderer.invalid,
        csc: this.cscRenderer.invalid
      }
    });
  }
  handleCardNumberInput() {
    const regexMap = {
      visa: /^^4\d{6,}$/,
      mastercard: /^5[1-5]\d{14}$/,
      amex: /^3[47]\d{5,}$/,
      diners: /^3(?:0[0-5]|[68]\d)\d{4,}$/,
      discover: /^6(?:011|5\d{2})\d{3,}$/,
      jcb: /^(?:2131|1800|35\d{3})\d{3,}$/,
      maestro: /^(5018|5020|5038|5612|5893|6304|6759|6761|6762|6763|0604|6390)\d+$/,
      unionpay: /^(62|88)\d+$/
    };
    for (const key in regexMap) {
      if (regexMap[key].test(this.cardNumberInput.value)) {
        this.creditCardType = key;
        return;
      }
    }
    this.creditCardType = "generic";
  }
  handleCardNumberBlur() {
    const maskCardNumber = () => {
      if (!this.cardNumber)
        return "";
      if (!this.cardNumber.length)
        return "";
      return [...this.cardNumber].reduce((acc, val, index) => {
        return `${acc}${index < this.cardNumber.length - 4 ? secureChar : val}`;
      }, "");
    };
    if (!this.cardNumberInput.value)
      return;
    if (this.cardNumberInput.value.includes(secureChar))
      return;
    this.cardNumberInput.value = maskCardNumber();
    this.handleInputBlur();
  }
  handleCardNumberFocus() {
    this.cardNumberInput.value = this.cardNumber || "";
  }
  handleCscNumberBlur() {
    this.cscInput.value = Array.from({ length: this.csc.length }).map(() => secureChar).join("");
    this.handleInputBlur();
  }
  handleCscNumberFocus() {
    var _a;
    this.cscInput.value = (_a = this.csc) != null ? _a : "";
  }
  renderFirstName() {
    return this.firstNameRenderer.render($`<input id="cc-given-name" name="cc-given-name" autocomplete="cc-given-name" class="credit-card__first-name" value=${this.firstName} ?disabled=${this.disabled} ?readonly=${this.readonly} @blur=${this.handleInputBlur} @change=${this.handleInputChange} required aria-required="true" size="1" />`, {
      label: t2("components:creditCard.firstName"),
      labelFor: "cc-given-name",
      hasValue: !!this.firstName
    });
  }
  renderLastName() {
    return this.lastNameRenderer.render($`<input id="cc-family-name" name="cc-family-name" autocomplete="cc-family-name" class="credit-card__last-name" value=${this.lastName} ?disabled=${this.disabled} ?readonly=${this.readonly} @blur=${this.handleInputBlur} @change=${this.handleInputChange} required aria-required="true" size="1" />`, {
      label: t2("components:creditCard.lastName"),
      labelFor: "cc-family-name",
      hasValue: !!this.lastName
    });
  }
  renderCreditCardIcon() {
    const icons = credit_card_icons_exports;
    return $`<span aria-hidden="true" class="credit-card__svg">${icons[this.creditCardType || "generic"]}</span>`;
  }
  renderCardNumber() {
    return this.cardNumberRenderer.render($`<input id="cc-number" name="cc-number" autocomplete="cc-number" class="credit-card__card-number" inputmode="numeric" maxlength="64" ?disabled=${this.disabled} ?readonly=${this.readonly} required aria-required="true" value=${this.cardNumber} @keydown=${this.handleRestrictedKeydown} @blur=${this.handleCardNumberBlur} @focus=${this.handleCardNumberFocus} @change=${this.handleInputChange} @input="${this.handleCardNumberInput}" size="1" />`, {
      label: t2("components:creditCard.cardNumber"),
      labelFor: "cc-number",
      hasValue: !!this.cardNumber
    }, void 0, this.renderCreditCardIcon());
  }
  renderMonthOptions() {
    return Array.from({ length: 12 }).map((_, i2) => {
      let value = `${i2 + 1}`;
      if (value.length < 2) {
        value = `0${value}`;
      }
      const date = new Date(2e3, i2, 1);
      return $`<option value=${value} selected=${l(value === this.month || void 0)}>${value} &dash; ${date.toLocaleString("default", { month: "long" })}</option>`;
    });
  }
  renderMonth() {
    return this.monthRenderer.render($`<select id="cc-exp-month" name="ccmonth" autocomplete="cc-exp-month" class="credit-card__month" value=${this.month} ?disabled=${this.disabled} ?readonly=${this.readonly} @blur=${this.handleInputBlur} @change=${this.handleInputChange} required aria-required="true" ><option></option>${this.renderMonthOptions()}</select>`, {
      label: t2("components:creditCard.month"),
      labelFor: "cc-exp-month",
      hasValue: !!this.month
    });
  }
  renderYearOptions() {
    const current = new Date(Date.now()).getFullYear();
    return Array.from({ length: 10 }).map((_, i2) => {
      const year = current + i2;
      return $`<option value=${year} selected=${l(year.toString() === this.year || void 0)}>${year}</option>`;
    });
  }
  renderYear() {
    return this.yearRenderer.render($`<select id="cc-exp-year" name="ccyear" autocomplete="cc-exp-year" class="credit-card__year" value=${this.year} ?disabled=${this.disabled} ?readonly=${this.readonly} @blur=${this.handleInputBlur} @change=${this.handleInputChange} required aria-required="true" ><option></option>${this.renderYearOptions()}</select>`, {
      label: t2("components:creditCard.year"),
      labelFor: "cc-exp-year",
      hasValue: !!this.year
    });
  }
  renderCsc() {
    return this.cscRenderer.render($`<input id="cc-csc" name="cvc" autocomplete="cc-csc" class="credit-card__csc" inputmode="numeric" maxlength="4" value=${this.csc} ?disabled=${this.disabled} ?readonly=${this.readonly} @keydown=${this.handleRestrictedKeydown} @change=${this.handleInputChange} @blur=${this.handleCscNumberBlur} @focus=${this.handleCscNumberFocus} size="1" required aria-required="true" />`, {
      label: t2("components:creditCard.csc"),
      labelFor: "cc-csc",
      hasValue: !!this.csc
    }, void 0, $`<span class="credit-card__tooltip"><fadv-tooltip content=${t2("components:creditCard.cscTooltip")} variant="primary"><fadv-icon class="credit-card__info-bubble" tabindex="0" size="small" library="solid" name="circle-info" foreground="primary" label=${t2("components:creditCard.cscInfoBubble")} ></fadv-icon></fadv-tooltip></span><span aria-hidden="true" class="credit-card__svg credit-card__csc-icon">${csc}</span>`);
  }
  render() {
    return $`<div class=${o({
      "credit-card": true,
      "credit-card--monochrome": this.variant === "monochrome"
    })} ><form><fadv-box ph="small" pb="xx-small"><fadv-typography type="label-medium" weight="500">${t2("components:creditCard.cardHolder")}</fadv-typography></fadv-box><fadv-grid><fadv-grid-row><fadv-grid-col col='{ "xs": "12", "sm": "6" }'>${this.renderFirstName()}</fadv-grid-col><fadv-grid-col col='{ "xs": "12", "sm": "6" }'>${this.renderLastName()}</fadv-grid-col></fadv-grid-row></fadv-grid><fadv-box ph="small" pt="medium" pb="xx-small"><fadv-typography type="label-medium" weight="500">${t2("components:creditCard.cardInformation")}</fadv-typography></fadv-box><fadv-grid><fadv-grid-row><fadv-grid-col>${this.renderCardNumber()}</fadv-grid-col></fadv-grid-row><fadv-grid-row><fadv-grid-col col='{ "xs": "12", "sm": "6" }'>${this.renderMonth()}</fadv-grid-col><fadv-grid-col col='{ "xs": "12", "sm": "6" }'>${this.renderYear()}</fadv-grid-col></fadv-grid-row><fadv-grid-row><fadv-grid-col>${this.renderCsc()}</fadv-grid-col></fadv-grid-row></fadv-grid></form></div>`;
  }
};
FadvCreditCard.styles = [credit_card_styles_default, form_control_styles_default, form_control_monochrome_styles_default, form_control_standard_styles_default, form_control_floating_styles_default, select_styles_default];
__decorateClass([
  e()
], FadvCreditCard.prototype, "firstName", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "lastName", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "cardNumber", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "month", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "year", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "csc", 2);
__decorateClass([
  e({ type: "boolean" })
], FadvCreditCard.prototype, "floating", 2);
__decorateClass([
  e()
], FadvCreditCard.prototype, "variant", 2);
__decorateClass([
  e({ type: Boolean })
], FadvCreditCard.prototype, "pill", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvCreditCard.prototype, "disabled", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvCreditCard.prototype, "readonly", 2);
__decorateClass([
  e({ type: Boolean })
], FadvCreditCard.prototype, "validateLuhn", 2);
__decorateClass([
  i(".credit-card__first-name")
], FadvCreditCard.prototype, "firstNameInput", 2);
__decorateClass([
  i(".credit-card__last-name")
], FadvCreditCard.prototype, "lastNameInput", 2);
__decorateClass([
  i(".credit-card__card-number")
], FadvCreditCard.prototype, "cardNumberInput", 2);
__decorateClass([
  i(".credit-card__month")
], FadvCreditCard.prototype, "monthSelect", 2);
__decorateClass([
  i(".credit-card__year")
], FadvCreditCard.prototype, "yearSelect", 2);
__decorateClass([
  i(".credit-card__csc")
], FadvCreditCard.prototype, "cscInput", 2);
__decorateClass([
  t()
], FadvCreditCard.prototype, "creditCardType", 2);
FadvCreditCard = __decorateClass([
  n("fadv-credit-card")
], FadvCreditCard);

export {
  checkLuhn,
  FadvCreditCard
};
